export const STATE_TYPES = {
  ENABLED: 1,
  DELETED: 2,
  DISABLED: 3,
  DRAFT: 4,
  PENDING_CAMPAIGN_CREATION: 5,
  STOPPED: 6,
  INVALID: 7,
}

// Estados dos Triggers/steps. Usado para controle de tela relacionado a validação dos campos.
export const TRIGGER_STEPS_STATES = {
  VALID: 1,
  INVALID: 2,
  NOT_EDITED: 3,
  NOT_VALIDATED: 4,
}

export const CHANNEL_TYPES = {
  SEND_EMAIL: 1,
  SEND_SMS: 2,
}

export const WORKFLOW_TYPES = {
  SEND_EMAIL: 1,
  SEND_SMS: 2,
}

export const TRIGGER_TYPES = {
  DATE: 1,
  NEW_CONTACT: 2,
  BEHAVIORAL: 3,
}

export const ACTION_TYPES = {
  ACTIVATE: 1,
  DEACTIVATE: 2,
  EDIT: 3,
  VIEW: 4,
  STATISTICS: 5,
  REMOVE: 6,
}

export const DESTINATION_STATUS = {
  ENABLED: 1,
  DISABLED: 2,
  DELETED: 3,
}

export const WORKFLOW_ERROR_TYPE = {
  INVALID_DESTINATION: 1,
  INVALID_SCHEMA: 2,
  INVALID_SEGMENT: 3,
  INVALID_SENDER: 4
}

export const STEP_TYPES = {
  AUTOMATION_DETAIL: 'automationDetails',
  AUDIENCE: 'audienceAction',
  ACTION: 'automationAction',
  CONTENT_SMS: 'automationSMSContent',
  CONTENT_EMAIL: 'automationEmailContent',
  CONTENT_UNDEFINED: 'automationUndefinedContent',
}

// Serve pra definir onde registrar o valor a ser atualizado dentro da estrutura de dados
export const FIELD_TYPE = {
  WORKFLOW: 0,
  TRIGGER: 1,
  STEP: 2,
  CONTROL: 3,
}

export const STEP_MODEL = [
  {
    id: 1,
    name: STEP_TYPES.AUTOMATION_DETAIL,
    translationKey: '001',
    component: 'Details',
    disabledOnEditMode: true,
  },
  {
    id: 2,
    name: STEP_TYPES.AUDIENCE,
    translationKey: '002',
    component: 'Audience',
    disabledOnEditMode: true,
  },
  {
    id: 3,
    name: STEP_TYPES.ACTION,
    translationKey: '003',
    component: 'Action',
    disabledOnEditMode: true,
  },
  {
    id: 4,
    name: STEP_TYPES.CONTENT_SMS,
    translationKey: '004',
    component: 'SMSContent',
    disabledOnEditMode: false,
  },
  {
    id: 5,
    name: STEP_TYPES.CONTENT_EMAIL,
    translationKey: '005',
    component: 'EmailContent',
    isFormInvalid: false,
    disabledOnEditMode: false,
  },
]

// TODO: ALTERAR VALORES DE-PARA IGUAL AO BACK
export const STATISTICS_TYPES = {
  DELIVERED: 0,
  NOT_DELIVERED: 1,
  PENDING: 2,
  OPEN: 3,
  CLICK: 4,
  BOUNCED: 5,
  UNSUBSCRIBE: 6,
}

export const STATISTICS_CHART_PERIOD_TYPES = {
  ONE_MONTH: {
    id: 1,
    months: 1,
  },
  THREE_MONTHS: {
    id: 2,
    months: 3,
  },
  SIX_MONTHS: {
    id: 3,
    months: 6,
  },
  TWELVE_MONTHS: {
    id: 4,
    months: 12,
  },
}

export const STATISTICS_EMAIL_PROPERTIES = [
  {
    name: 'open',
    type: STATISTICS_TYPES.OPEN,
  },
  {
    name: 'click',
    type: STATISTICS_TYPES.CLICK,
  },
  {
    name: 'bounced',
    type: STATISTICS_TYPES.BOUNCED,
  },
  {
    name: 'unsubscribe',
    type: STATISTICS_TYPES.UNSUBSCRIBE,
  },
]

export const STATISTICS_SMS_PROPERTIES = [
  {
    name: 'delivered',
    type: STATISTICS_TYPES.DELIVERED,
  },
  {
    name: 'notDelivered',
    type: STATISTICS_TYPES.NOT_DELIVERED,
  },
  {
    name: 'pending',
    type: STATISTICS_TYPES.PENDING,
  },
]

export const WORKFLOW_MODES = {
  VIEW: 1,
  EDIT: 2,
}

export const DLR_STATUS = {
  DELIVERED: 0,
  PENDING: 1,
  NOT_DELIVERED: 2,
}
